/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { goodLuckCoreEntitiesAchievementDefinitionSchema } from "./achievementDefinitionSchema.ts";
import { goodLuckCoreEntitiesUserSchema } from "./userSchema.ts";
import { z } from "zod/v4";

export const goodLuckCoreEntitiesUserAchievementSchema = z.object({
  id: z.optional(z.int()),
  userId: z.string().min(1),
  get user() {
    return goodLuckCoreEntitiesUserSchema.optional();
  },
  achievementDefinitionId: z.int(),
  get achievementDefinition() {
    return goodLuckCoreEntitiesAchievementDefinitionSchema.optional();
  },
  earnedAt: z.optional(z.iso.datetime()),
  progressValue: z.optional(z.int()),
});
